import { CmsPage, CmsModuleType, Page } from '@packages/common';

export function getContentfulRedirect(
  data: CmsPage,
): { pageType: Page; redirectUrl: string; statusCode: number } | null {
  const redirect = data?.modules?.main?.filter((item) => item.contentType === CmsModuleType.REDIRECT)[0];

  if (redirect) {
    const { redirectUrl, pageType, statusCode } = redirect as any;
    return {
      pageType,
      redirectUrl,
      statusCode,
    };
  }
  return null;
}
